import React, { useContext, useEffect, useMemo, useState } from 'react';
import { getGTDRSelectorList } from '@/pages/dashboard/services/benchmark';
import { shallowEqual, useSelector } from 'umi';
// import { formatSelectorToLanguageMap } from '@/pages/dashboard/utils/utils';
import { getName } from '@home/utils/common';
import { StudioContext } from '@home/pages/studio/context';
import GameDefault from '@/pages/home/assets/img/common/game-default.svg';

const formatVersionList = (data: { game_code: string; version: string; description_en: string; description_cn: string; }[]) => {
  // 使用filter和concat方法将description_en为'latest'的项放到最前面
  const latestArr = data?.filter(item => item.description_en?.toLowerCase() === 'latest') || [];
  const otherArr = data?.filter(item => item.description_en?.toLowerCase() !== 'latest') || [];
  return latestArr.concat(otherArr);
};

export const useFilterData = (isEN: boolean, system?: string, api?: string | undefined) => {
  const [selectorList, setSelectorList] = useState<{ [key: string]: any[]; }>({
    version: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const { dbdCurentGame } = useSelector((state: any) => ({
    dbdCurentGame: state.dashboard?.currentGame,
    // gameList: state.dashboard?.gameList || []
  }), shallowEqual);

  const { currentGame: studioCurrentGame } = useContext(StudioContext);

  const isStudio = system === 'studio';
  const currentGame = isStudio ? studioCurrentGame : dbdCurentGame;

  const studioCode = studioCurrentGame?.studio_code;

  const gameCode = currentGame?.game_code;
  const gameCover = currentGame?.cover;
  const gameName = useMemo(() => getName(isEN, currentGame?.game_name, isStudio ? currentGame?.game_name_cn : currentGame?.game_cn_name), [isEN, currentGame]);

  useEffect(() => {
    if (!gameCode) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(false);

    getGTDRSelectorList(api, {
      game_code: gameCode,
      ...(studioCode ? { studio_code: studioCode } : {})
    })
      .then((data) => {
        const versionList = formatVersionList(data?.version_list || []);
        setSelectorList({ version: versionList });
      })
      .catch((e) => {
        console.error('getGTDRSelectorList', e);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [api, gameCode,studioCode]);

  const renderText = (props: { item: any; describe: any; }) => {
    const { item, describe } = props || {};
    return (
      <>
        <span>{item?.text}</span>
        <span className='dbd-benchmark-version-filter-item-des'>&nbsp;{describe}</span>
      </>
    );
  };

  const { versionOptions } = useMemo(() => {
    const versionList = selectorList?.version || [];
    // const gameListMap = formatSelectorToLanguageMap(gameList, 'game_code', 'cover', 'game_name', 'game_cn_name', isEN);

    const versionOptions = versionList.map((item: { game_code: string; version: string; description_en: string; description_cn: string; }, index: number) => {
      // game_code: code, 
      const { version, description_en, description_cn } = item || {};
      const describe = (index === 0 && description_en?.toLowerCase() === 'latest') ? (getName(isEN, description_en, description_cn) || getName(isEN, 'Latest', '最新')) : '';
      return {
        value: version,
        // 注意有空格
        text: `${gameName} - ${version}` || "",
        icon: gameCover || GameDefault,
        render: (item: { text: any; }) => renderText({ item, describe })
      };
    });

    return { versionOptions };
  }, [selectorList?.version, isEN, gameName, gameCover]);

  return {
    loading,
    error,
    selector: selectorList,
    versionOptions,
    // gameListMap,
    gameName,
    gameCode,
    gameCover,
    latestVersionObj: selectorList?.version?.[0]?.description_en?.toLowerCase() === 'latest' ? selectorList?.version?.[0] : {},
    studioCode
    // latestVersionObj: selectorList?.version?.filter(item=>item.description_en?.toLowerCase()  === 'latest')?.[0]
  };
};